<template>
    <div>
          <el-dialog
            title="修改券有效期"
            :visible.sync="showDialog"
            width="770px"
            :close-on-click-modal="false"
            :before-close="handleClose"
            class="changeBox"
            >
             <div class="specialReminder"> 
                 <i class="el-icon-warning remindIcon"></i>
                 <div class="ml10">
                    <div>1.优惠券变更会影响用户资产等权益，请您谨慎操作并提前与用户充分沟通达成一致，您的操作导致的一切后果由您自行承担。</div>
                    <div>2、仅支持对未使用状态的优惠券进行变更，如变更后的有效期截止日期早于当前日期，券状态同时变为“已过期”，优惠券无法再使用。</div>
                    <div>3、如活动启用了券过期提醒通知，系统按照新的截止日期推送券过期提醒短信或微信。</div>
                 </div>
              </div>
              <div class="stapTitel">第一步：下载券模版填写数据</div>
               <div class="stepContent">
                   点击此处 <a href="https://s3plus.meituan.net/v1/mss_61ac5135885c44e59bbaa7e9b2f3282e/static/coupon/%E4%BC%98%E6%83%A0%E5%88%B8%E6%89%B9%E9%87%8F%E6%93%8D%E4%BD%9C%E5%AF%BC%E5%85%A5.xls" target="_blank" class="activeText">下载券数据模板</a> 如需查看券码状态或下载券码，可点此前往 
                   <span class="activeText" >优惠券统计表</span> 
                    <el-tooltip class="item" effect="dark"  placement="top">
                        <div slot="content" class="tooltipSolt">导入的券码，如果已经使用或券码不存在，系统无法操作变更，请核实修改后重新上传。可以到 数据报表-财务报表-优惠券统计表 中，在 发券数量 列点击到明细，并下载券码。</div>
                         <img src="@/assets/images/doubt.png" class="doubtIcon ml10">
                    </el-tooltip>
                   下载
               </div>
                <div class="stapTitel">第二步：上传填写完的券模板</div>
                  <div class="stepContent">
                        <el-upload
                            class="upload-demo"
                            drag
                            :action="$uploadURL"
                            :file-list="fileList"
                            accept=".xls,.xlsx"
                            :on-success="handleSuccess"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                <div>点击或将文件拖拽到这里上传</div>
                                <div class="uploadTips">每次导入限制数量应小于100000条，文件小于10M，只能上传 xls | xlsx 格式的文件</div>
                            </div>
                        </el-upload>
                    </div>
                <div class="stapTitel">第三步：批量修改券有效期</div>
                <div class="stepContent">
                     <el-radio-group v-model="radioForm.radioSelect">
                            <div>
                              <el-radio :label="1">全部失效
                                <el-tooltip class="item" effect="dark"  placement="right">
                                    <div slot="content" class="tooltipSolt">将选中券码批量状态变为已过期，优惠券无法再使用，顾客微信卡券包中的优惠券变为已过期状态。</div>
                                    <img src="@/assets/images/doubt.png" class="doubtIcon ml10">
                                </el-tooltip>
                              </el-radio>
                            </div>
                            <div class="mt30">
                            <el-radio :label="2">
                                延长有效期 <el-input v-model="radioForm.extendDays" placeholder="1-1000" style="width:110px;" :disabled="radioForm.radioSelect == 2 ? false:true"></el-input> 天
                            </el-radio>
                            </div>
                            <div class="mt30"> 
                            <el-radio :label="3">
                                缩短有效期 <el-input v-model="radioForm.shortenDays" placeholder="1-1000" style="width:110px;" :disabled="radioForm.radioSelect == 3 ? false:true"></el-input> 天
                            </el-radio>
                            </div>
                            <div class="mt30 mb30">
                            <el-radio :label="4">
                                调整券截至日期
                                <el-date-picker
                                :disabled="radioForm.radioSelect == 4 ? false:true"
                                  v-model="radioForm.changeDate"
                                  type="datetime"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  placeholder="选择日期时间">
                                </el-date-picker>
                            </el-radio>
                            </div>
                     </el-radio-group>                          
                </div>
             <span slot="footer" class="dialog-footer">
                <div>
                <el-checkbox v-model="isRead" style="color:#000;">我已阅读并同意 <span class="isRead">《法律声明》</span></el-checkbox>
                 </div>
                 <div class="flex">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="confirm" :disabled="!isRead">开始导入</el-button>
                 </div>
            </span>
          </el-dialog>
          <!-- 导出成功弹框 -->
          <el-dialog
              title=""
              :visible.sync="successDialogVisible"
              width="500px"
              :show-close='false'
              class="successDialog"
              >
              <div class="flex itemsCenter">
                  <i class="el-icon-warning warningIcon"></i>
                  <span class="tipsText">提示</span>
              </div>
              <div class="tipsContent">
                导入已提交，导入结果及相关文件请前往批量操作记录中查看
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="successDialogVisible = false">取消</el-button>
                <el-button type="primary">立即前往</el-button>
              </span>
            </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            successDialogVisible:false,
            isRead:false,
            fileList:[],
            total:0,
           showDialog:false,
           radioForm:{
            radioSelect:0,
            extendDays:'',
            shortenDays:'',
            changeDate:'',
           }
        }
    },
     props:{
        dialogDateVisible:{
            type: Boolean,
            default:false,
        }
     },
     watch:{
        dialogDateVisible:{
            handler(newVal,oldVal){
                this.showDialog = newVal
            },
            deep:true,
            immediate:true,
        }
     },
      methods:{
        cancel(){
           this.$emit('handleDateClose',false)
           this.showDialog = false
        },
        confirm(){
           this.$emit('handleDateClose',false)
           this.showDialog = false
           this.successDialogVisible = true
           this.isRead = false
        },
        //下载文件
        downLoadFile(row){
        //window.open(downloadPath)
        },
        handleClose(){
             this.$emit('handleDateClose',false)
             this.showDialog = false
        },
        //文件上传成功
        handleSuccess(res, file, fileList){
           console.log('上传',res,file);
        },
     }
}
</script>

<style lang="less" scoped>
 /deep/ .el-table th>.cell{
    font-size: 15px;
    color: #222;
    font-weight: 500;
 }
 /deep/ .changeBox .el-dialog__header{
    border-bottom: 1px solid #e5e5e5;
 }
 /deep/ .changeBox .el-dialog__footer{
    border-top: 1px solid #e5e5e5;
    padding:15px 20px;
 }
 /deep/ .changeBox .el-dialog__body{
   padding: 24px 0;
   max-height: 520px;
   overflow-y: scroll;
 }
 .titel{
    font-size: 17px;
    color: #333;
    line-height: 24px;
    margin-bottom: 8px;
 }
 .activeText{
    color: #fe8c00;
    cursor: pointer;
 }
 /deep/ .el-upload-dragger .el-upload__text{
    font-size: 16px;
    color: #222;
 }
 /deep/ .el-upload-dragger .el-upload__text em{
     color: #fe8c00;
 }
 .uploadTips{
    color: rgba(0,0,0,.65);
    line-height: 25px;
    font-size: 15px;
    margin-top:10px;
 }
 /deep/ .el-upload-dragger{
    border: none;
    background: rgba(0,0,0,0.04);
    border-color: rgba(0,0,0,.15);
    width: 685px !important;
    height: 152px;
 }
 /deep/ .el-upload-dragger .el-icon-upload{
    margin: 20px 0 12px;
 }
 .specialReminder{
    padding: 15px;
    background: #fffae6;
    border: 1px solid #ffd100;
    border-radius: 7px;
    // height: 40px;
    display: flex;
    // align-items: center;
    margin-bottom: 30px;
    font-size: 15px;
    color: #666;
    width: 89%;
    margin: 0 auto;
}
.remindIcon{
//    width: 18px;
//    height: 18px;
 color: #fb7807;
 font-size: 17px;
}
.stapTitel{
    font-size: 14px;
    font-weight: 600;
    background-image: linear-gradient(90deg,rgba(255,199,55,.8),rgba(255,201,91,.35) 10%,rgba(255,201,111,0) 15%);
    border-radius: 2px 0 0 2px;
    padding-left: 24px;
    color:#222;
    margin-top: 24px;
    padding:3px 24px;
}
 .activeText{
    color: #fe8c00;
    cursor: pointer;
 }
 .stepContent{
    width: 89%;
    margin: 0 auto;
    margin-top: 24px;
 }
 .doubtIcon{
    width: 15px;
    height: 15px;
 }
 .doubtIcon{
    width: 15px;
    height: 15px;
    cursor: pointer;
    position: relative;
    top: 2px;
}
.tooltipSolt{
    width:30vw;
    font-size:13px;
    line-height:20px;
}
.mt30{
    margin-top: 30px;
}
.mb30{
    margin-bottom: 30px;
}
 /deep/ .el-radio__input.is-checked .el-radio__inner{
    border-color: rgb(245,154,35);
    background: rgb(245,154,35);
 }
 /deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #222;
 }
 /deep/ .el-radio__label{
    font-size: 15px;
 }
 /deep/ .el-radio{
    color: #222;
    font-size: 16px;
 }
 /deep/ .el-radio__inner:hover{
    border-color: rgb(245,154,35);
 }
 /deep/ .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
    color: #999;
    background: #eee;
    border-color: #d9d9d9;
}
 .changeBox .dialog-footer{
    display: flex;
    justify-content: space-between;
}
.isRead{
   color: rgb(245,154,35);
   cursor: pointer;
}
.isRead:hover{
       border-bottom: 1px solid rgb(245,154,35);
}
 /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    border-color: rgb(245,154,35);
    background: rgb(245,154,35);
 }
 /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #606266;
}
 /deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: rgb(245,154,35) !important;
 } 
  /deep/ .el-checkbox__input .el-checkbox__inner:hover{
    border-color: rgb(245,154,35) !important;
  }
  .successDialog /deep/ .el-dialog__body{
    padding:0 30px 30px 30px;
  }
  .successDialog /deep/ .el-dialog{
    border-radius: 5px;
    margin-top: 20vh !important;
  }
  .warningIcon{
    color: #f59a23;
    font-size: 25px;
  }
  .tipsText{
    font-size: 16px;
    color: #222;
    margin-left: 20px;
  }
  .itemsCenter{
    align-items: center;
  }
  .tipsContent{
    font-size: 14px;
    color: #666;
    margin-top: 8px;
    margin-left: 43px;
    line-height: 23px;
  }
  /deep/ .el-button:focus,
.el-button:hover {
  color: rgb(245, 154, 35);
  border-color: #f5dab1;
  background-color: #fdf6ec;
}
</style>